import React from 'react'
import { ChevronDown, MapPin, Calendar, Users } from 'lucide-react'

const Hero: React.FC = () => {
  const scrollToContent = () => {
    document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <section id="home" className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-wudang-blue/80 via-wudang-blue/60 to-wudang-green/40 z-10" />
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1545569341-9eb8b30979d9?auto=format&fit=crop&w=2000)'
          }}
        />
      </div>

      {/* Content */}
      <div className="relative z-20 container mx-auto px-4 text-center">
        <div className="max-w-4xl mx-auto">
          {/* Title */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 font-english-title">
            Wudang Mountain
          </h1>
          
          {/* Subtitle */}
          <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-2xl mx-auto">
            Taoist Holy Land · Birthplace of Martial Arts · World Cultural Heritage
          </p>

          {/* Description */}
          <p className="text-lg text-white/80 mb-12 max-w-3xl mx-auto leading-relaxed">
            Explore the birthplace of Chinese Taoist culture, experience millennia of martial arts heritage, and feel the charm of a World Cultural Heritage site. Wudang Mountain attracts visitors and pilgrims from around the world with its unique natural landscape, profound cultural heritage, and exquisite architectural art.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
            <button 
              onClick={() => document.getElementById('travel')?.scrollIntoView({ behavior: 'smooth' })}
              className="btn-primary text-lg px-8 py-4 flex items-center justify-center gap-2"
            >
              <MapPin className="w-5 h-5" />
              Start Exploring
            </button>
            <button 
              onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
              className="btn-secondary text-lg px-8 py-4"
            >
              Practical Info
            </button>
          </div>

          {/* Contact Email */}
          <div className="mb-12">
            <p className="text-xl font-semibold text-white mb-3">
              Need help? Contact us:
            </p>
            <a 
              href="mailto:info@hellowudang.com" 
              className="inline-block bg-white text-wudang-blue px-6 py-3 rounded-lg text-lg font-bold hover:bg-gray-100 transition-colors shadow-lg"
            >
              📧 info@hellowudang.com
            </a>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="flex items-center justify-center gap-3 mb-2">
                <Calendar className="w-6 h-6 text-wudang-yellow" />
                <span className="text-2xl font-bold text-white">1413</span>
              </div>
              <p className="text-white/80 text-sm">
                Years of Architecture History
              </p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="flex items-center justify-center gap-3 mb-2">
                <MapPin className="w-6 h-6 text-wudang-yellow" />
                <span className="text-2xl font-bold text-white">72</span>
              </div>
              <p className="text-white/80 text-sm">
                Taoist Temples
              </p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="flex items-center justify-center gap-3 mb-2">
                <Users className="w-6 h-6 text-wudang-yellow" />
                <span className="text-2xl font-bold text-white">2M+</span>
              </div>
              <p className="text-white/80 text-sm">
                Annual Visitors
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={scrollToContent}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce"
      >
        <ChevronDown className="w-8 h-8 text-white/70" />
      </button>
    </section>
  )
}

export default Hero